var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4495 4.5504C15.1455 4.24642 14.6527 4.2464 14.3486 4.55036L9.99917 8.89914L5.65048 4.55045C5.3465 4.24648 4.85364 4.24656 4.54978 4.55064V4.55064C4.2461 4.85454 4.24615 5.34703 4.54988 5.65087L8.89836 10.0007L4.55004 14.3491C4.24623 14.6529 4.24614 15.1454 4.54984 15.4493V15.4493C4.85368 15.7534 5.34649 15.7535 5.65046 15.4496L9.99917 11.1015L14.3487 15.4496C14.6527 15.7536 15.1455 15.7535 15.4494 15.4496V15.4496C15.7534 15.1455 15.7534 14.6526 15.4494 14.3487L11.1008 10.0007L15.4495 5.65126C15.7535 5.34724 15.7535 4.85439 15.4495 4.5504V4.5504Z",
    fill: "#31313D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThin);
export default __webpack_public_path__ + "static/media/cross-thin.407de195217781b9a3137f8c2437c126.svg";
export { ForwardRef as ReactComponent };